import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";

//STYLES
import * as SectionsStyles from "./styles/sections";

//COMPONENTS
import PageNavigationButtons from "../navBar/pageNavigationButtons";
import ContentSection from "./contentSection";

function ServicesAndEvents() {
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);

    const [mobileSubNavBarShow, setMobileSubNavBarShow] = useState(false);

    const [subNavBarSelection, setSubNavBarSelection] = useState(3);

    const [pageID, setPageID] = useState(0);

    useEffect(() => {
        const pageUUID = pagesUUIDs.find((page) => page.section == 3).uuid;
        setPageID(pageUUID);
    }, []);

    const pagesUUIDs = [
        { section: 0, uuid: 4 },
        { section: 1, uuid: 5 },
        { section: 2, uuid: 6 },
        { section: 3, uuid: 7 }
    ];

    function navBarSectionChange(section) {
        setSubNavBarSelection(section);
        const pageUUID = pagesUUIDs.find((page) => page.section == section).uuid;
        setPageID(pageUUID);
    }

    const browserSubNavBar = (
        <Row>
            <Col
                style={subNavBarSelection == 0 ? SectionsStyles.subNavBarLinksSelected : SectionsStyles.subNavBarLinks}
                onClick={navBarSectionChange.bind(this, 0)}
            >
                Celebration Service
            </Col>
            <Col
                style={subNavBarSelection == 1 ? SectionsStyles.subNavBarLinksSelected : SectionsStyles.subNavBarLinks}
                onClick={navBarSectionChange.bind(this, 1)}
            >
                What’s On
            </Col>
            <Col
                style={subNavBarSelection == 2 ? SectionsStyles.subNavBarLinksSelected : SectionsStyles.subNavBarLinks}
                onClick={navBarSectionChange.bind(this, 2)}
            >
                Podcasts
            </Col>
            <Col
                style={subNavBarSelection == 3 ? SectionsStyles.subNavBarLinksSelected : SectionsStyles.subNavBarLinks}
                onClick={navBarSectionChange.bind(this, 3)}
            >
                Photos / Videos
            </Col>
        </Row>
    );

    function toggleMobileMenu() {
        if (!mobileSubNavBarShow) {
            setMobileSubNavBarShow(true);
        } else {
            setMobileSubNavBarShow(false);
        }
    }

    function mobileSectionClick(section) {
        setMobileSubNavBarShow(false);
        setSubNavBarSelection(section);
    }

    const mobileSubNavBar = (
        <div>
            <div style={SectionsStyles.topNavBar}>
                <div style={SectionsStyles.topBar}>
                    <div style={SectionsStyles.topBarIcon} onClick={toggleMobileMenu}>
                        <i className="fa-solid fa-bars fa-2xl"></i>
                    </div>
                    {mobileSubNavBarShow && (
                        <div style={SectionsStyles.mobileNav_navBody}>
                            <div
                                style={
                                    subNavBarSelection == 0
                                        ? { ...SectionsStyles.mobileNav_navButtonSelected, borderRadius: "0 25px 0 0" }
                                        : { ...SectionsStyles.mobileNav_navButton, borderRadius: "0 25px 0 0" }
                                }
                                onClick={mobileSectionClick.bind(this, 0)}
                            >
                                Celebration Service
                            </div>
                            <div
                                style={subNavBarSelection == 1 ? SectionsStyles.mobileNav_navButtonSelected : SectionsStyles.mobileNav_navButton}
                                onClick={mobileSectionClick.bind(this, 1)}
                            >
                                What’s On
                            </div>
                            <div
                                style={subNavBarSelection == 2 ? SectionsStyles.mobileNav_navButtonSelected : SectionsStyles.mobileNav_navButton}
                                onClick={mobileSectionClick.bind(this, 2)}
                            >
                                Podcasts
                            </div>
                            <div
                                style={
                                    subNavBarSelection == 3
                                        ? { ...SectionsStyles.mobileNav_navButtonSelected, borderRadius: "0 0 25px 0" }
                                        : { ...SectionsStyles.mobileNav_navButton, borderRadius: "0 0 25px 0" }
                                }
                                onClick={mobileSectionClick.bind(this, 3)}
                            >
                                Photos / Videos
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <div
            style={{
                border: "1px solid black",
                height: "100vh",
                width: "100vw",
                backgroundImage: `url('/content/mainStyle/homeSections/backgroundImages/image3.jpeg')`,
                backgroundSize: "cover"
            }}
        >
            <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_blueBackground : SectionsStyles.blueBackground}>
                <PageNavigationButtons />
                <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_insideContainer : SectionsStyles.insideContainer}>
                    <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_whiteCentredSection : SectionsStyles.whileCentredSection}>
                        {GS_generalSettings.isMobile ? mobileSubNavBar : browserSubNavBar}
                        <div style={SectionsStyles.contentContianer}>
                            <ContentSection pageID={pageID} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServicesAndEvents;
